import { render, staticRenderFns } from "./CategoryDashboard.vue?vue&type=template&id=83d2532c&scoped=true"
import script from "./CategoryDashboard.vue?vue&type=script&lang=js"
export * from "./CategoryDashboard.vue?vue&type=script&lang=js"
import style0 from "./CategoryDashboard.vue?vue&type=style&index=0&id=83d2532c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d2532c",
  null
  
)

export default component.exports